<!-- Navigation -->
<calsoft-vertical-navigation class="bg-indigo-800 theme-dark"
                          [appearance]="'futuristic'"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="data.navigation.futuristic[0]"
                          [opened]="!isScreenSmall">

    <div calsoftVerticalNavigationHeader>
        <div class="logo">
          <img [src]="path" style="width: 100px;
    padding-bottom: 25px;" onerror="this.src='assets/images/logo/2.png';" alt="">

        </div>
    </div>

 

</calsoft-vertical-navigation>



<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">

        <!-- Navigation toggle button -->
        <button [attr.guide]="'futuristic-btn-1' + '__' + sanitizeUrl(url)" class="navigation-toggle-button"
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'menu'"></mat-icon>
        </button>

        <!-- Spacer -->
        <div class="spacer"></div>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <!-- Footer -->
    <div class="footer">
        Calsoft &copy; {{currentYear}}
    </div>

</div>